import { render, staticRenderFns } from "./marketplace.vue?vue&type=template&id=c4aa3910&scoped=true"
import script from "./marketplace.vue?vue&type=script&lang=js"
export * from "./marketplace.vue?vue&type=script&lang=js"
import style0 from "./marketplace.vue?vue&type=style&index=0&id=c4aa3910&prod&scoped=true&lang=css"
import style1 from "./marketplace.vue?vue&type=style&index=1&id=c4aa3910&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4aa3910",
  null
  
)

export default component.exports